import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const CatAndSubCatDefaultCategoryFragmentDoc = gql`
  fragment CatAndSubCatDefaultCategory on Category {
    id
    name
    parent {
      id
      name
    }
  }
` as unknown as DocumentNode<Types.CatAndSubCatDefaultCategoryFragment, unknown>
